import { createAction } from 'redux-actions';

const basename = 'APP';

export const APP = {
  INIT_AUTH_INFO: `${basename}/INIT_AUTH_INFO`,
  SET_USER_INFO: `${basename}/SET_USER_INFO`,
  LOGIN: `${basename}/LOGIN`,
  LOGOUT: `${basename}/LOGOUT`,
  APP_START_BROWSER: 'APP_START_BROWSER'
};

export const login = createAction(APP.LOGIN, (userId, accessToken, userInfo) => ({
  userId,
  accessToken,
  userInfo
}));

export const initAuthInfo = createAction(APP.INIT_AUTH_INFO, (userId, accessToken, userInfo) => ({
  userId,
  accessToken,
  userInfo
}));

export const setUserInfo = createAction(APP.SET_USER_INFO, userInfo => ({
  userInfo
}));

export const appStartBrowser = createAction(APP.APP_START_BROWSER);

export const logout = createAction(APP.LOGOUT);



// WEBPACK FOOTER //
// ./src/actions/app.js